import React from 'react';
import Carousel from '../carousel/carousel';



class Mantra33_4 extends React.Component {
    render() {
        return (
            <div>
                <Carousel />
                <img src="/assets/img/preview.png" className="img-fluid d-block" style={{width : '100px', margin : '20px auto 0px auto'}} alt="" />
                <img src="/assets/img/home.png" className="img-fluid mantr6_img" alt="" />
                <div className="container">
                    <div className="mantra33_upload_div">
                        <img src="/assets/img/img-18.jpg" className="img-fluid d-block mx-auto user_img" alt="" />
                        <img src="/assets/img/multistar.png" className="img-fluid multistar_img" alt="" />
                        <img src="/assets/img/camera.png" className="img-fluid change_img" alt="" />

                    </div>
                    <div className="upload_heading">
                        <h5>Upload your parent’s photo</h5>
                    </div>



                    <table className="table table-bordered table-responsive table_class">
                        <thead>
                            <tr>
                                <th className="serail_bg">No</th>
                                <th className="parameter_bg">PARAMETERS</th>
                                <th className="rating_bg">RATING</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Openness</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star1"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star2"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star3"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star4"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star5"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star6"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star7"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star8"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star9"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star10"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Approachab</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>

                            <tr>
                                <td>3</td>
                                <td>Cool Quotient</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star1"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star2"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star3"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star4"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star5"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star6"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star7"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star8"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star9"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star10"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Patience</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>

                            <tr>
                                <td>5</td>
                                <td>Flexiblity</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star1"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star2"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star3"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star4"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star5"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star6"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star7"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star8"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star9"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star10"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Humor</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>


                            <tr>
                                <td>7</td>
                                <td>Support</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star1"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star2"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star3"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star4"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star5"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star6"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star7"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star8"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star9"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star10"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Respect</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>


                            <tr>
                                <td>9</td>
                                <td>Loving</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star1"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star2"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star3"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star4"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star5"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star6"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star7"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star8"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star9"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star10"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>Approachab</td>
                                <td>
                                    <ul className="star_rating">
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                        <li className="star"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                                    </ul>
                                </td>
                            </tr>
                            
                            
                        </tbody>
                    </table>

                    <div className="total_score">
                        <h6>TOTAL SCORE <span>19</span>/100</h6>
                    </div>

                    <div className="preview_btn">
                        <button type="button" className="share2_btn">Done &amp; Share</button>
                    </div>


                </div>

            </div>

        )
    }
}

export default Mantra33_4;